import React from 'react';
import Button from '../../../../../../components/buttons/Button';
import { useTranslator } from '../../../../../../components/i18n/useTranslator';
import TagRenameField from './TagRenameField';
import { TagEditContentProps } from '../tagComponentPropTypes';
import TagDeleteButton from './TagDeleteButton';

const TagEditContent: React.FC<TagEditContentProps> = (props) => {
    const {
        tag,
        onMoveMenuClick,
        onColorChangeClick,
        closePopups,
        taggedElements,
        userRootPath,
        boardVirtualPathToRootMap,
    } = props;

    const translate = useTranslator('popup', 'tags.edit');

    if (!tag) return null;

    return (
        <div className="TagEditContent">
            <Button
                className="flex w-48 !mx-6 !pt-2 !pb-1 !px-4 hover:!bg-gray-100"
                id={`tag-color-${tag.id}`}
                onClick={onColorChangeClick}
            >
                {translate('changeColor')}
            </Button>
            {userRootPath.length > 1 && (
                <Button
                    className="flex w-48 !mx-6 !py-1 !px-4 hover:!bg-gray-100"
                    id={`tag-move-${tag.id}`}
                    onClick={onMoveMenuClick}
                >
                    {translate('move')}
                </Button>
            )}
            <TagDeleteButton
                tag={tag}
                closePopups={closePopups}
                taggedElements={taggedElements}
                userRootPath={userRootPath}
                boardVirtualPathToRootMap={boardVirtualPathToRootMap}
                translate={translate}
            />
            {/* FIXME WEB-15187 (Update tag rename logic) */}
            <div className="flex w-48 !mx-6 !pt-1 !pb-2 !px-3">
                <TagRenameField {...props} />
            </div>
        </div>
    );
};

export default TagEditContent;
